document.addEventListener('DOMContentLoaded', function() {
  // Only run on /account/register
  if (!window.location.pathname.includes('/account/register')) return;

  // Find the Horizon form container
  const formContainer = document.querySelector('form#create_customer');
  if (!formContainer) return;

  // --- Create Mobile Field ---
  const mobileField = document.createElement('div');
  mobileField.className = 'field';
  mobileField.innerHTML = `
    <label for="Mobile" class="field__label">Mobile Number</label>
    <input type="text" name="customer[metafields][custom.mobile]" id="Mobile" class="field__input" placeholder="Enter your mobile number" required>
  `;
  formContainer.insertBefore(mobileField, formContainer.querySelector('button[type="submit"]'));

  // --- Create Birthdate Field ---
  const birthdateField = document.createElement('div');
  birthdateField.className = 'field';
  birthdateField.innerHTML = `
    <label for="Birthdate" class="field__label">Birthdate</label>
    <input type="date" name="customer[metafields][custom.birthdate]" id="Birthdate" class="field__input" required>
  `;
  formContainer.insertBefore(birthdateField, formContainer.querySelector('button[type="submit"]'));

  // --- Create Preferences Field ---
  const preferencesField = document.createElement('div');
  preferencesField.className = 'field';
  preferencesField.innerHTML = `
    <label for="Preferences" class="field__label">Preferences</label>
    <textarea name="customer[metafields][custom.preferences]" id="Preferences" class="field__input" placeholder="Tell us your preferences (optional)" rows="3"></textarea>
  `;
  formContainer.insertBefore(preferencesField, formContainer.querySelector('button[type="submit"]'));
});
